import {PhotoViewerModel} from './model/photo-viewer-model';
import { Subject } from 'rxjs';

export class PhotoViewerService {
  show$: Subject<PhotoViewerModel> = new Subject<PhotoViewerModel>();

  public show(urls: string[], photoIndex: number) {
    this.show$.next(new PhotoViewerModel(urls, photoIndex));
  }
}
